// schema
import * as ISchema from "@schema";
// libraries
import React from "react";

// components
import { HoursAndPreferencesSections } from "../web-settings";

import { RoomPreferencesSettings } from "@components/room-preferences-settings";

// util
// import { logger } from "@util/logger.util";

// styles
// import { colors, helpers } from "@clockwise/web-commons/src/styles/color.styles";

// material-ui
import { Typography } from "@material-ui/core";
// import { makeStyles } from "@material-ui/styles";

// ~-~-~-~-~-~-~-
// Time of Day Preference Settings
// ~-~-~-~-~-~-~-
interface WebSettingsPreferredMeetingRoomsProps {
  viewer: ISchema.IViewer;
  org: ISchema.IOrg;
}

// const useStyles = makeStyles({});

export const WebSettingsPreferredMeetingRooms = (props: WebSettingsPreferredMeetingRoomsProps) => {
  // const classes = useStyles();

  // ~-~-~-~-~-~-~-
  // Helpers
  // ~-~-~-~-~-~-~-

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  return (
    <div
      cw-id={`web-settings-${HoursAndPreferencesSections.PreferredMeetingRooms}`}
      className="cw-mb-16"
    >
      <Typography variant="h3" className="cw-mb-4">
        Preferred meeting rooms
      </Typography>
      <Typography variant="subtitle1" className="cw-mb-6">
        Tell Clockwise which meeting rooms you prefer to meet in so we can provide better
        suggestions when scheduling.
      </Typography>
      <RoomPreferencesSettings viewer={props.viewer} org={props.org} isWebSettings />
    </div>
  );
};
